import { motion } from 'framer-motion';
import type { TaskLineItem } from '../../types/proposal';
import { formatCurrency } from '../../utils';

interface TaskLineItemsProps {
  lineItems: TaskLineItem[];
}

export function TaskLineItems({ lineItems }: TaskLineItemsProps) {
  if (!lineItems || lineItems.length === 0) {
    return null;
  }

  return (
    <motion.div
      className="mt-4 pt-4 border-t border-gray-100"
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      transition={{ duration: 0.3 }}
    >
      <div className="text-xs uppercase tracking-wider text-gray-400 mb-3 font-heading">
        Line Items
      </div>
      <div className="space-y-2">
        {lineItems.map((item, index) => (
          <div
            key={index}
            className="flex items-center justify-between text-sm"
          >
            <div className="flex items-center gap-2 text-gray-600">
              <span className="w-1 h-1 bg-gray-400 rounded-full" />
              <span>{item.description}</span>
              {item.quantity !== 1 && (
                <span className="text-gray-400">
                  ({item.quantity} @ {formatCurrency(item.rate)})
                </span>
              )}
            </div>
            <div className="font-mono text-gray-700">
              {formatCurrency(item.amount)}
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
